import React from "react";
import AlertTemplate from "~/common/components/AlertPortal/AlertTemplate";

import { useTranslation } from "react-i18next";

const ProcessAlerts = ({
	noCategoryAlert,
	setNoCategoryAlert,
	weightingAlert,
	setWeightingAlert,
	deleteAlertModal,
	setDeleteAlertModal,
	noEvaluationAlert,
	setNoEvaluationAlert,
	noTitleAlert,
	setNoTitleAlert,
	noCategoryName,
	setNoCategoryName,
	noItemName,
	setNoItemName,
	doDelete,
	targetIdx,
}) => {
	const { t } = useTranslation();
	return (
		<>
			{/* ---- ProcessOne Modals --------------------------------------------------- */}
			{/* 심사평가 제목 비었을때 Alert 창 필요. */}
			<AlertTemplate
				alertModalState={noTitleAlert}
				setAlertModalToggle={setNoTitleAlert}
				width={420}
				alertType="warning"
			>
				<p className="alert-content">
					<div className="modal-text">{t("pages.round.RoundSetting.processingModal.ProcessAlerts.inputTitle")}</div>
				</p>
				<div className="alert-footer">
					<button
						className="btn__solid"
						color="primary"
						onClick={() => setNoTitleAlert(false)}
					>
						{t("pages.round.RoundSetting.processingModal.ProcessAlerts.check")}
					</button>
				</div>
			</AlertTemplate>

			{/* ---- ProcessTwo Modals --------------------------------------------------- */}
			{/* 카테고리 없을때, 평가항목 없을때 모달 둘다 필요 */}
			{/*카테고리 없을 때(.no-content) AlertModal*/}
			<AlertTemplate
				alertModalState={noCategoryAlert}
				setAlertModalToggle={setNoCategoryAlert}
				width={420}
				alertType="warning"
			>
				<p className="alert-content">
					<div className="modal-text">{t("pages.round.RoundSetting.processingModal.ProcessAlerts.enrollCate")}</div>
				</p>
				<div className="alert-footer">
					<button
						className="btn__solid"
						color="primary"
						onClick={() => setNoCategoryAlert(false)}
					>
						{t("pages.round.RoundSetting.processingModal.ProcessAlerts.check")}
					</button>
				</div>
			</AlertTemplate>

			<AlertTemplate
				alertModalState={noEvaluationAlert}
				setAlertModalToggle={setNoEvaluationAlert}
				width={420}
				alertType="warning"
			>
				<p className="alert-content">
					<div className="modal-text">{t("pages.round.RoundSetting.processingModal.ProcessAlerts.noCate")}</div>
				</p>
				<div className="alert-footer">
					<button
						className="btn__solid"
						color="primary"
						onClick={() => setNoEvaluationAlert(false)}
					>
						{t("pages.round.RoundSetting.processingModal.ProcessAlerts.check")}
					</button>
				</div>
			</AlertTemplate>

			{/* 카테고리 아무것도 입력 안했을때 */}
			<AlertTemplate
				alertModalState={noCategoryName}
				setAlertModalToggle={setNoCategoryName}
				width={420}
				alertType="warning"
			>
				<p className="alert-content">
					<div className="modal-text">{t("pages.round.RoundSetting.processingModal.ProcessAlerts.enrollCateName")}</div>
				</p>
				<div className="alert-footer">
					<button
						className="btn__solid"
						color="primary"
						onClick={() => setNoCategoryName(false)}
					>
						{t("pages.round.RoundSetting.processingModal.ProcessAlerts.check")}
					</button>
				</div>
			</AlertTemplate>

			{/* 평가항목 아무것도 입력 안했을때 */}
			<AlertTemplate
				alertModalState={noItemName}
				setAlertModalToggle={setNoItemName}
				width={420}
				alertType="warning"
			>
				<p className="alert-content">
					<div className="modal-text">{t("pages.round.RoundSetting.processingModal.ProcessAlerts.evalueName")}</div>
				</p>
				<div className="alert-footer">
					<button
						className="btn__solid"
						color="primary"
						onClick={() => setNoItemName(false)}
					>
						{t("pages.round.RoundSetting.processingModal.ProcessAlerts.check")}
					</button>
				</div>
			</AlertTemplate>

			{/* ---- ProcessThree Modals --------------------------------------------------- */}
			{/*가중치 합이 100% 아닐 때 모달*/}
			<AlertTemplate
				alertModalState={weightingAlert}
				setAlertModalToggle={setWeightingAlert}
				width={420}
				alertType="warning"
			>
				<p className="alert-content">
					<div className="modal-text">{t("pages.round.RoundSetting.processingModal.ProcessAlerts.settingSum")}</div>
				</p>
				<div className="alert-footer">
					<button
						className="btn__solid"
						color="primary"
						onClick={() => setWeightingAlert(false)}
					>
						{t("pages.round.RoundSetting.processingModal.ProcessAlerts.check")}
					</button>
				</div>
			</AlertTemplate>

			{/* ---- ProcessFinal Modals --------------------------------------------------- */}
			{/* <AlertTemplate
				alertModalState={finishProcessing}
				setAlertModalToggle={setFinishProcessing}
				alertType={"success"}
			>
				<p className="alert-content">
					<div className="modal-text">심사항목 설정을 완료하시겠습니까?</div>
				</p>
				<div className="alert-footer">
					<button
						className="btn__solid"
						color="gray"
						onClick={() => setFinishProcessing(false)}
					>
						아니요
					</button>
					<button className="btn__solid" color="primary" onClick={() => setConfirmFinish("confirm")}>
						예
					</button>
				</div>
			</AlertTemplate> */}

			{/*심사항목 삭제 Alert 모달*/}
			<AlertTemplate
				alertModalState={deleteAlertModal}
				setAlertModalToggle={setDeleteAlertModal}
				alertType={"warning"}
			>
				<p className="alert-content">
					<div className="modal-text">{t("pages.round.RoundSetting.processingModal.ProcessAlerts.removeEvaluate")}</div>
				</p>
				<div className="alert-footer">
					<button
						className="btn__solid"
						color="gray"
						onClick={() => setDeleteAlertModal(false)}
					>
						{t("pages.round.RoundSetting.processingModal.ProcessAlerts.non")}
					</button>
					<button
						className="btn__solid"
						color="primary"
						onClick={() => doDelete(targetIdx)}
					>
						{t("pages.round.RoundSetting.processingModal.ProcessAlerts.yes")}
					</button>
				</div>
			</AlertTemplate>
		</>
	);
};

export default ProcessAlerts;
